/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ImportSnippetsIntoCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['fromCourseId', codecNumber, 'from_course_id'],
]);
export class ImportSnippetsIntoCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ImportSnippetsIntoCourseDataParser.decode(input).map(res => new ImportSnippetsIntoCourseData(res));
    }
    static unsafeDecode(input) {
        return ImportSnippetsIntoCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ImportSnippetsIntoCourseDataParser.encode(data);
    }
    static schema() {
        return ImportSnippetsIntoCourseDataParser.schema();
    }
}
